import React from "react";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

const CriticidadeMediaGGPI = ({ flag, criticidade }) => {
	return (
		<>
			{(flag.PI || flag.TT) && (
				<Box
					sx={{
						width: "100%",
						maxWidth: 600,
						bgcolor: "background.paper",
					}}
					className="m-auto"
				>
					<Box sx={{ my: 3, mx: 2 }}>
						<Grid container alignItems="center">
							<Grid item xs>
								<Typography
									gutterBottom
									variant="h4"
									component="div"
								>
									Geração e Gestão da Propriedade Intelectual
								</Typography>
							</Grid>
						</Grid>
					</Box>

					<Divider variant="middle" />

					<Box sx={{ m: 2 }}>
						{flag.PI && (
							<Paper className="m-2 p-3">{criticidade.PI}</Paper>
						)}

						{flag.TT && (
							<Paper className="m-2 p-3">{criticidade.TT}</Paper>
						)}
					</Box>
				</Box>
			)}
		</>
	);
};

export default CriticidadeMediaGGPI;
